import axios from 'axios'
import { SlidoAuthService } from '../utils/auth'
import { API_BASE } from '../utils/env'

export const api = axios.create({
  baseURL: API_BASE.replace(/\/$/, ''),
  withCredentials: true,
  timeout: 600000,
})

let activeRequests = 0
let pageLoading = false

function broadcastLoadingState() {
  if (typeof window === 'undefined') return
  if (window.self === window.top) return
  const loading = activeRequests > 0 || pageLoading
  window.parent.postMessage({ type: 'slido-loading-state', loading }, '*')
}

export function setPageLoading(loading: boolean) {
  pageLoading = loading
  broadcastLoadingState()
}

api.interceptors.request.use((config) => {
  activeRequests += 1
  broadcastLoadingState()

  const token = SlidoAuthService.getAuthToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  async (res) => {
    activeRequests = Math.max(0, activeRequests - 1)
    broadcastLoadingState()
    return res
  },
  async (err) => {
    activeRequests = Math.max(0, activeRequests - 1)
    broadcastLoadingState()
    return Promise.reject(err)
  }
)
